'use client';

import React, { memo, useCallback, useEffect, useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const SHOW_THRESHOLD = 320;

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let lastVisible = window.scrollY > SHOW_THRESHOLD;
    setVisible(lastVisible);

    const handleScroll = () => {
      const nextVisible = window.scrollY > SHOW_THRESHOLD;
      if (nextVisible !== lastVisible) {
        lastVisible = nextVisible;
        setVisible(nextVisible);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollUp = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <button
      type="button"
      onClick={scrollUp}
      aria-label="Back to top"
      title="Back to top"
      className="fixed bottom-6 right-6 z-50 inline-flex h-12 w-12 items-center justify-center rounded-full border border-white/20 bg-gradient-to-br from-primary to-accent text-white shadow-[0_14px_35px_rgba(37,99,235,0.35)] outline-none transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_45px_rgba(37,99,235,0.45)] focus-visible:ring-4 focus-visible:ring-primary/25 sm:bottom-8 sm:right-8"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0) scale(1)' : 'translateY(12px) scale(0.92)',
        pointerEvents: visible ? 'auto' : 'none',
        transition: 'opacity 0.3s ease, transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.3s ease',
      }}
    >
      <span className="absolute inset-0 rounded-full bg-white/15 opacity-0 transition-opacity duration-300 hover:opacity-100" aria-hidden="true" />
      <Icon name="ArrowUpIcon" size={20} className="relative z-10" />
    </button>
  );
}

export default memo(BackToTop);
